<template>
  <vuex-table
    :fields="fields"
    :show_per_page="false"
    table_store="pbx/stats/detailed/table"
    :tooltip_text="$t('pbx.stat.tooltips.one_sip_account')"
  >
    <template slot="peer" slot-scope="{ item }">
      {{ item.peer }}
    </template>

    <template #actions="{ detailsShowing, toggleDetails, item }">
      <template v-if="item.recording">
        <table-button-more :is_show="detailsShowing" @click="toggleDetails" />
      </template>
      <template v-else> – </template>
    </template>

    <template #row-details="{ item }">
      <p v-if="item.music_file" class="row-details-item">
        <strong class="row-details-item__label">{{ $t('pbx.stat.table.field.recording') }}:</strong>
        <file-player-row
          :music="item.music_file"
          :title="item.contact_name"
          class="row-details-item__content row-details-item__content--player"
        />

        <a :href="download_link(item.music_file.src)" download>
          <img src="/img/icons/btn-download.svg" alt="" width="20" />
        </a>
      </p>
    </template>
  </vuex-table>
</template>
  <script>
  import { toUserDateWithTime } from '@shared/helpers/date_format';
  import { seconds_to_time } from '@shared/helpers/time';
  import FilePlayerRow from '@shared/components/z-player-row';
  import TableButtonMore from '@shared/components/table/table-cell-toggle-detail';

  export default {
    components: {
      FilePlayerRow,
      TableButtonMore
    },
    computed: {
      fields() {
        return [
          {
            key: 'type',
            label: this.$t('pbx.stat.detailed.field.type'),
            sortable: true,
            formatter: (value) => this.$t(`pbx.stat.call_type.${value}`),
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'destination',
            label: this.$t('pbx.stat.detailed.field.destination'),
            sortable: true,
            formatter: (value) => this.$t(`pbx.stat.call_destination.${value}`),
            thStyle: {
              minWidth: '150px'
            }
          },

          {
            key: 'src_number',
            label: this.$t('pbx.stat.table.field.src'),
            thStyle: {
              minWidth: '150px'
            },
            sortable: true
          },

          {
            key: 'dst_number',
            label: this.$t('pbx.stat.table.field.dst'),
            thStyle: {
              minWidth: '150px'
            },
            sortable: true
          },

          {
            key: 'date',
            label: this.$t('pbx.stat.table.field.date'),
            sortable: true,
            formatter: (value) => toUserDateWithTime(value),
            thStyle: {
              minWidth: '170px'
            }
          },

          {
            key: 'duration_billed',
            label: this.$t('pbx.stat.table.field.duration'),
            formatter: (value) => seconds_to_time(value),
            thStyle: {
              minWidth: '100px'
            },
            sortable: false
          },

          {
            key: 'state',
            label: this.$t('pbx.stat.table.field.type_answer'),
            formatter: (value) => this.$t(`pbx.stat.type_answer.${value}`),
            thStyle: {
              minWidth: '120px'
            },
            sortable: true
          },
          {
            key: 'peer',
            label: this.$t('pbx.stat.table.field.sip_account'),
            thStyle: {
              minWidth: '150px'
            },
            sortable: true
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            sortable: false,
            class: 'text-center',
            thStyle: { width: '120px' }
          }
        ];
      }
    },

    methods: {
      download_link(item) {
        const folder = item.split('/')[3];
        const name = item.split('/')[4];

        return `https://storage.zorra.com/download.php?file=${folder}/${name}`;
      }
    }
  };
  </script>

  <style lang="scss">
    .row-details-item {
      &__label {
        margin-right: 5px;
      }
      &__content {
        &--player {
          display: inline-block;
          max-width: 500px;
          margin: 0 20px;

          .player button.download {
            display: block;
          }
        }
      }

      &:last-child {
        margin-bottom: 0;
        display: flex;
        align-items: center;
      }
    }
  </style>
